import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

/**
 * Simple modal that lets an Owner change a teammate's role. Parent controls
 * the target member, the chosen new role, and the submit handler.
 */
const RoleChangeDialog = ({
  member,
  newRole,
  setNewRole,
  saving,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={!!member} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-sm border border-zinc-200  rounded-none p-0">
        <DialogHeader className="p-6 pb-0">
          <DialogTitle className="text-2xl font-heading font-bold uppercase tracking-wide">Change Role</DialogTitle>
        </DialogHeader>

        {member && (
          <div className="p-6 pt-4 space-y-4">
            <p className="text-zinc-500">
              Update role for <span className="font-bold">{member.name}</span>
            </p>

            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">New Role</label>
              <select
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
              >
                <option value="Owner">Owner</option>
                <option value="Project Manager">Project Manager</option>
                <option value="Foreman">Foreman</option>
              </select>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 h-14 bg-white text-zinc-900 font-bold uppercase border border-zinc-200 hover:bg-zinc-50"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                disabled={saving || newRole === member.role}
                className="flex-1 h-14 bg-primary text-zinc-900 font-bold uppercase border border-zinc-200  hover:bg-primary-hover active:translate-y-1 disabled:opacity-50"
              >
                {saving ? 'Saving...' : 'Update Role'}
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RoleChangeDialog;
